import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, vModelText as _vModelText, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "hope-cert-block" }
const _hoisted_2 = {
  class: "ltc-info-title",
  style: {"margin-top":"24px"}
}
const _hoisted_3 = { class: "cert-section" }
const _hoisted_4 = {
  key: 0,
  class: "cert-loading"
}
const _hoisted_5 = {
  key: 1,
  class: "cert-registered"
}
const _hoisted_6 = { class: "ltc-info-table" }
const _hoisted_7 = {
  key: 0,
  class: "expire-warning"
}
const _hoisted_8 = {
  key: 1,
  class: "expire-warning"
}
const _hoisted_9 = { colspan: "3" }
const _hoisted_10 = {
  key: 2,
  class: "cert-not-registered"
}
const _hoisted_11 = { class: "cert-empty-icon" }
const _hoisted_12 = { class: "cert-upload-modal" }
const _hoisted_13 = { class: "modal-header modal-header--dark" }
const _hoisted_14 = { class: "modal-body" }
const _hoisted_15 = {
  key: 0,
  class: "cert-loading"
}
const _hoisted_16 = {
  key: 0,
  class: "cert-mode-tabs"
}
const _hoisted_17 = {
  key: 1,
  class: "password-only-mode"
}
const _hoisted_18 = { class: "current-cert-info" }
const _hoisted_19 = { class: "info-value" }
const _hoisted_20 = { class: "info-sub" }
const _hoisted_21 = { class: "upload-field" }
const _hoisted_22 = { class: "password-input-wrap" }
const _hoisted_23 = ["type"]
const _hoisted_24 = {
  key: 2,
  class: "password-only-mode"
}
const _hoisted_25 = { class: "upload-field" }
const _hoisted_26 = { class: "upload-field" }
const _hoisted_27 = { class: "password-input-wrap" }
const _hoisted_28 = ["type"]
const _hoisted_29 = { class: "cert-guide npki-guide" }
const _hoisted_30 = { class: "guide-header" }
const _hoisted_31 = { class: "guide-steps" }
const _hoisted_32 = { class: "guide-step" }
const _hoisted_33 = { class: "step-content" }
const _hoisted_34 = { class: "path-box" }
const _hoisted_35 = { class: "cert-change-notice" }
const _hoisted_36 = { class: "cert-notice hope-login-notice" }
const _hoisted_37 = { class: "upload-field" }
const _hoisted_38 = { class: "cert-pick-actions" }
const _hoisted_39 = {
  key: 0,
  class: "drop-zone-content"
}
const _hoisted_40 = {
  key: 1,
  class: "drop-zone-files"
}
const _hoisted_41 = { class: "file-status" }
const _hoisted_42 = { class: "file-status" }
const _hoisted_43 = {
  key: 0,
  class: "change-hint"
}
const _hoisted_44 = { class: "upload-field" }
const _hoisted_45 = { class: "password-input-wrap" }
const _hoisted_46 = ["type"]
const _hoisted_47 = { class: "password-hint" }
const _hoisted_48 = { class: "upload-field" }
const _hoisted_49 = { class: "upload-field" }
const _hoisted_50 = { class: "password-input-wrap" }
const _hoisted_51 = ["type"]
const _hoisted_52 = { class: "cert-notice" }
const _hoisted_53 = { class: "modal-footer" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = ["disabled"]
const _hoisted_56 = ["disabled"]
const _hoisted_57 = ["disabled"]
const _hoisted_58 = ["disabled"]
const _hoisted_59 = { class: "delete-confirm-dialog" }
const _hoisted_60 = ["disabled"]
const _hoisted_61 = { class: "dialog-icon" }
const _hoisted_62 = { class: "dialog-actions" }
const _hoisted_63 = ["disabled"]

import { ref, computed, watch, onMounted } from 'vue';
import { hopeCertApi } from '@/services/api';
import { pickNpkiCertFiles, NPKI_PATH_HINT } from '@/utils/pickNpkiCertFiles';


export default /*@__PURE__*/_defineComponent({
  __name: 'HopeCertSection',
  props: {
    mCode: {}
  },
  setup(__props: any) {

const props = __props;

const loading = ref(false);
const certInfo = ref<any>(null);
const showModal = ref(false);
const showDeleteDialog = ref(false);
const editMode = ref<'password' | 'credentials' | 'full'>('full');
const saving = ref(false);
const loadingCredentials = ref(false);

// 파일/입력 상태
const fileInputRef = ref<HTMLInputElement | null>(null);
const folderInputRef = ref<HTMLInputElement | null>(null);
const signCertFile = ref<File | null>(null);
const signPriFile = ref<File | null>(null);
const pickedFolderHint = ref('');
const isDragOver = ref(false);
const certPassword = ref('');
const newPassword = ref('');
const hopeId = ref('');
const hopePw = ref('');
const showPw = ref(false);
const showCertPw = ref(false);
const showHopePw = ref(false);

// 스낵바
const snackbar = ref(false);
const snackbarText = ref('');
const snackbarColor = ref('success');
const notify = (text: string, color = 'success') => {
  snackbarText.value = text;
  snackbarColor.value = color;
  snackbar.value = true;
};

const copyNpkiPath = async () => {
  try {
    await navigator.clipboard.writeText(NPKI_PATH_HINT);
    notify('경로가 복사되었습니다.');
  } catch {
    const textarea = document.createElement('textarea');
    textarea.value = NPKI_PATH_HINT;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    notify('경로가 복사되었습니다.');
  }
};

const canUpload = computed(() =>
  !!signCertFile.value && !!signPriFile.value &&
  !!certPassword.value.trim() && !!hopeId.value.trim() && !!hopePw.value.trim()
);

const certExpireDayDiff = (raw: unknown) => {
  if (!raw) return null;
  const expireDate = new Date(raw as string);
  if (Number.isNaN(expireDate.getTime())) return null;
  const expire = new Date(expireDate.getFullYear(), expireDate.getMonth(), expireDate.getDate());
  const today = new Date();
  const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  return Math.round((expire.getTime() - todayStart.getTime()) / (1000 * 60 * 60 * 24));
};

const isExpired = computed(() => {
  const diffDays = certExpireDayDiff(certInfo.value?.chc_expire_date);
  return diffDays !== null && diffDays < 0;
});

const isExpiringSoon = computed(() => {
  const diffDays = certExpireDayDiff(certInfo.value?.chc_expire_date);
  return diffDays !== null && diffDays <= 30 && diffDays >= 0;
});

const formatDate = (d: any) => {
  if (!d) return '-';
  const date = new Date(d);
  if (isNaN(date.getTime())) return '-';
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};
const formatDateTime = (d: any) => {
  if (!d) return '-';
  const date = new Date(d);
  if (isNaN(date.getTime())) return '-';
  return `${formatDate(d)} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
};

const loadInfo = async () => {
  if (!props.mCode) { certInfo.value = null; return; }
  loading.value = true;
  try {
    const res = await hopeCertApi.getInfo(props.mCode);
    certInfo.value = res.data?.data || null;
  } catch (error: any) {
    if (error.response?.status !== 404) {
      const msg = error.response?.data?.message || error.message || '알 수 없는 오류';
      notify(`희망이음 인증서 조회 실패: ${msg}`, 'error');
    }
    certInfo.value = null;
  } finally {
    loading.value = false;
  }
};

const resetInputs = () => {
  signCertFile.value = null;
  signPriFile.value = null;
  pickedFolderHint.value = '';
  certPassword.value = '';
  newPassword.value = '';
  hopeId.value = '';
  hopePw.value = '';
  showPw.value = false;
  showCertPw.value = false;
  showHopePw.value = false;
};

const loadHopeCredentials = async () => {
  if (!props.mCode || !certInfo.value?.chc_idx) return;
  loadingCredentials.value = true;
  try {
    const res = await hopeCertApi.getCredentials(props.mCode);
    const data = res.data?.data;
    if (data) {
      hopeId.value = data.hopeId || '';
      hopePw.value = data.hopePw || '';
    }
  } catch (error: any) {
    const msg = error.response?.data?.message || error.message || '알 수 없는 오류';
    notify(`희망이음 로그인정보 조회 실패: ${msg}`, 'error');
  } finally {
    loadingCredentials.value = false;
  }
};

const openModal = async () => {
  resetInputs();
  // 만료된 인증서는 전체 변경이 기본
  editMode.value = certInfo.value && !isExpired.value ? 'password' : 'full';
  showModal.value = true;
  if (certInfo.value) {
    await loadHopeCredentials();
  }
};
const closeModal = () => {
  showModal.value = false;
  resetInputs();
};

const enableDirectoryPicker = (el: HTMLInputElement | null) => {
  if (!el) return;
  (el as HTMLInputElement & { webkitdirectory?: boolean }).webkitdirectory = true;
  el.setAttribute('webkitdirectory', '');
  el.setAttribute('directory', '');
  el.multiple = true;
};

const triggerFolderInput = () => {
  enableDirectoryPicker(folderInputRef.value);
  folderInputRef.value?.click();
};

const triggerFileInput = () => fileInputRef.value?.click();

const assignFiles = (files: FileList | File[]) => {
  const picked = pickNpkiCertFiles(files);
  if (!picked.ok) {
    notify(picked.message, 'error');
    return;
  }
  signCertFile.value = picked.der;
  signPriFile.value = picked.key;
  pickedFolderHint.value = picked.pairDir;
};

const onFolderChange = (e: Event) => {
  const input = e.target as HTMLInputElement;
  if (input.files) assignFiles(input.files);
  input.value = '';
};

const onFilesChange = (e: Event) => {
  const input = e.target as HTMLInputElement;
  if (input.files) assignFiles(input.files);
  input.value = '';
};

const onDrop = (e: DragEvent) => {
  isDragOver.value = false;
  if (e.dataTransfer?.files) assignFiles(e.dataTransfer.files);
};

const upload = async () => {
  if (!props.mCode || !canUpload.value) return;
  saving.value = true;
  try {
    const formData = new FormData();
    formData.append('mCode', String(props.mCode));
    formData.append('signCert', signCertFile.value as File);
    formData.append('signPri', signPriFile.value as File);
    formData.append('password', certPassword.value);
    formData.append('hopeId', hopeId.value.trim());
    formData.append('hopePw', hopePw.value.trim());
    await hopeCertApi.upload(formData);
    notify('희망이음 인증서가 등록되었습니다.');
    closeModal();
    await loadInfo();
  } catch (error: any) {
    const msg = error.response?.data?.message || error.message || '알 수 없는 오류';
    const status = error.response?.status || '';
    notify(`희망이음 인증서 등록 실패: ${msg}${status ? ` (${status})` : ''}`, 'error');
  } finally {
    saving.value = false;
  }
};

const changePassword = async () => {
  if (!certInfo.value?.chc_idx || !newPassword.value.trim()) return;
  saving.value = true;
  try {
    await hopeCertApi.updatePassword(certInfo.value.chc_idx, newPassword.value.trim());
    notify('인증서 비밀번호가 변경되었습니다.');
    closeModal();
    await loadInfo();
  } catch (error: any) {
    const msg = error.response?.data?.message || error.message || '알 수 없는 오류';
    notify(`비밀번호 변경 실패: ${msg}`, 'error');
  } finally {
    saving.value = false;
  }
};

const changeCredentials = async () => {
  if (!certInfo.value?.chc_idx || !hopeId.value.trim() || !hopePw.value.trim()) return;
  saving.value = true;
  try {
    await hopeCertApi.updateCredentials(certInfo.value.chc_idx, hopeId.value.trim(), hopePw.value.trim());
    notify('희망이음 로그인정보가 변경되었습니다.');
    closeModal();
    await loadInfo();
  } catch (error: any) {
    const msg = error.response?.data?.message || error.message || '알 수 없는 오류';
    notify(`로그인정보 변경 실패: ${msg}`, 'error');
  } finally {
    saving.value = false;
  }
};

const deleteCert = async () => {
  if (!certInfo.value?.chc_idx) return;
  saving.value = true;
  try {
    await hopeCertApi.delete(certInfo.value.chc_idx);
    notify('희망이음 인증서가 삭제되었습니다.');
    showDeleteDialog.value = false;
    closeModal();
    await loadInfo();
  } catch (error: any) {
    const msg = error.response?.data?.message || error.message || '알 수 없는 오류';
    notify(`인증서 삭제 실패: ${msg}`, 'error');
  } finally {
    saving.value = false;
  }
};

watch(() => props.mCode, () => loadInfo());
onMounted(() => loadInfo());

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_icon, {
        size: "18",
        class: "mr-1"
      }, {
        default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
          _createTextVNode("mdi-account-key", -1)
        ]))]),
        _: 1
      }),
      _cache[26] || (_cache[26] = _createTextVNode(" 희망이음 공동인증서 ", -1)),
      _cache[27] || (_cache[27] = _createElementVNode("span", { class: "hope-cert-badge" }, "개인 인증서", -1)),
      (certInfo.value && !loading.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "edit-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal()))
          }, [
            _createVNode(_component_v_icon, { size: "14" }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createTextVNode("mdi-pencil", -1)
              ]))]),
              _: 1
            }),
            _cache[25] || (_cache[25] = _createTextVNode(" 수정 ", -1))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              size: "20",
              width: "2"
            }),
            _cache[28] || (_cache[28] = _createElementVNode("span", null, "희망이음 인증서 정보 확인 중...", -1))
          ]))
        : (certInfo.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("table", _hoisted_6, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _cache[29] || (_cache[29] = _createElementVNode("th", null, "발급자", -1)),
                    _createElementVNode("td", null, _toDisplayString(certInfo.value.chc_cert_name || '-'), 1),
                    _cache[30] || (_cache[30] = _createElementVNode("th", null, "만료일", -1)),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass({ 'cert-date-alert': isExpired.value || isExpiringSoon.value })
                      }, [
                        _createTextVNode(_toDisplayString(formatDate(certInfo.value.chc_expire_date)) + " ", 1),
                        (isExpired.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "만료되었습니다"))
                          : (isExpiringSoon.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "(만료 임박)"))
                            : _createCommentVNode("", true)
                      ], 2)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[31] || (_cache[31] = _createElementVNode("th", null, "희망이음 아이디", -1)),
                    _createElementVNode("td", null, _toDisplayString(certInfo.value.chc_hope_id_masked || '-'), 1),
                    _cache[32] || (_cache[32] = _createElementVNode("th", null, "마지막 사용", -1)),
                    _createElementVNode("td", null, _toDisplayString(certInfo.value.chc_last_used ? formatDateTime(certInfo.value.chc_last_used) : '사용 기록 없음'), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[33] || (_cache[33] = _createElementVNode("th", null, "등록일", -1)),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(formatDateTime(certInfo.value.chc_wdate)), 1)
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_v_icon, {
                  size: "40",
                  color: "grey-lighten-1"
                }, {
                  default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                    _createTextVNode("mdi-account-key-outline", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[37] || (_cache[37] = _createElementVNode("p", { class: "cert-empty-text" }, "등록된 희망이음 공동인증서가 없습니다", -1)),
              _cache[38] || (_cache[38] = _createElementVNode("p", { class: "cert-empty-hint" }, "개인 공동인증서와 희망이음 아이디/비밀번호를 등록하면 희망이음 자동화 기능을 이용할 수 있습니다", -1)),
              _createElementVNode("button", {
                class: "cert-upload-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (openModal()))
              }, [
                _createVNode(_component_v_icon, { size: "16" }, {
                  default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                    _createTextVNode("mdi-upload", -1)
                  ]))]),
                  _: 1
                }),
                _cache[36] || (_cache[36] = _createTextVNode(" 희망이음 인증서 등록 ", -1))
              ])
            ]))
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((showModal).value = $event)),
      "max-width": "600",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h3", null, _toDisplayString(certInfo.value ? '희망이음 공동인증서 관리' : '희망이음 공동인증서 등록'), 1),
            _createElementVNode("button", {
              class: "close-btn",
              onClick: closeModal
            }, [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            (loadingCredentials.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    size: "20",
                    width: "2"
                  }),
                  _cache[40] || (_cache[40] = _createElementVNode("span", null, "희망이음 로그인정보 불러오는 중...", -1))
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (certInfo.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("button", {
                          class: _normalizeClass(['mode-tab', { active: editMode.value === 'password' }]),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (editMode.value = 'password'))
                        }, [
                          _createVNode(_component_v_icon, {
                            size: "16",
                            class: "mr-1"
                          }, {
                            default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                              _createTextVNode("mdi-key", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[42] || (_cache[42] = _createTextVNode(" 비밀번호 변경 ", -1))
                        ], 2),
                        _createElementVNode("button", {
                          class: _normalizeClass(['mode-tab', { active: editMode.value === 'credentials' }]),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (editMode.value = 'credentials'))
                        }, [
                          _createVNode(_component_v_icon, {
                            size: "16",
                            class: "mr-1"
                          }, {
                            default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                              _createTextVNode("mdi-account", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[44] || (_cache[44] = _createTextVNode(" 아이디/비번 변경 ", -1))
                        ], 2),
                        _createElementVNode("button", {
                          class: _normalizeClass(['mode-tab', { active: editMode.value === 'full' }]),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (editMode.value = 'full'))
                        }, [
                          _createVNode(_component_v_icon, {
                            size: "16",
                            class: "mr-1"
                          }, {
                            default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                              _createTextVNode("mdi-certificate", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[46] || (_cache[46] = _createTextVNode(" 인증서 전체 변경 ", -1))
                        ], 2)
                      ]))
                    : _createCommentVNode("", true),
                  (certInfo.value && editMode.value === 'password')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _cache[47] || (_cache[47] = _createElementVNode("div", { class: "info-label" }, "현재 등록된 인증서", -1)),
                          _createElementVNode("div", _hoisted_19, _toDisplayString(certInfo.value.chc_cert_name || '알 수 없음'), 1),
                          _createElementVNode("div", _hoisted_20, "만료일: " + _toDisplayString(formatDate(certInfo.value.chc_expire_date)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _cache[48] || (_cache[48] = _createElementVNode("label", null, [
                            _createTextVNode("새 인증서 비밀번호 "),
                            _createElementVNode("span", { class: "required" }, "*")
                          ], -1)),
                          _createElementVNode("div", _hoisted_22, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newPassword).value = $event)),
                              type: showPw.value ? 'text' : 'password',
                              class: "native-input full-width",
                              placeholder: "새 인증서 비밀번호를 입력하세요"
                            }, null, 8, _hoisted_23), [
                              [_vModelDynamic, newPassword.value]
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "toggle-password-btn",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (showPw.value = !showPw.value))
                            }, [
                              _createVNode(_component_v_icon, { size: "18" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(showPw.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (certInfo.value && editMode.value === 'credentials')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _cache[49] || (_cache[49] = _createElementVNode("label", null, [
                            _createTextVNode("희망이음 아이디 "),
                            _createElementVNode("span", { class: "required" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((hopeId).value = $event)),
                            type: "text",
                            class: "native-input full-width",
                            placeholder: "희망이음 로그인 아이디",
                            name: "hope_ssis_login_id",
                            autocomplete: "off",
                            autocapitalize: "off",
                            spellcheck: "false"
                          }, null, 512), [
                            [_vModelText, hopeId.value]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _cache[50] || (_cache[50] = _createElementVNode("label", null, [
                            _createTextVNode("희망이음 비밀번호 "),
                            _createElementVNode("span", { class: "required" }, "*")
                          ], -1)),
                          _createElementVNode("div", _hoisted_27, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((hopePw).value = $event)),
                              type: showHopePw.value ? 'text' : 'password',
                              class: "native-input full-width",
                              placeholder: "희망이음 로그인 비밀번호",
                              name: "hope_ssis_login_pw",
                              autocomplete: "new-password"
                            }, null, 8, _hoisted_28), [
                              [_vModelDynamic, hopePw.value]
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "toggle-password-btn",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (showHopePw.value = !showHopePw.value))
                            }, [
                              _createVNode(_component_v_icon, { size: "18" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(showHopePw.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!certInfo.value || editMode.value === 'full')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_v_icon, {
                              size: "20",
                              color: "primary"
                            }, {
                              default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                _createTextVNode("mdi-information", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[52] || (_cache[52] = _createElementVNode("strong", null, "인증서 폴더 한 번에 올리기", -1))
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _cache[58] || (_cache[58] = _createElementVNode("div", { class: "guide-step" }, [
                              _createElementVNode("div", { class: "step-number" }, "1"),
                              _createElementVNode("div", { class: "step-content" }, [
                                _createElementVNode("span", { class: "step-title" }, "아래 「인증서 폴더 선택」 버튼 클릭"),
                                _createElementVNode("span", { class: "step-desc" }, "폴더를 고르는 창이 열립니다.")
                              ])
                            ], -1)),
                            _createElementVNode("div", _hoisted_32, [
                              _cache[57] || (_cache[57] = _createElementVNode("div", { class: "step-number" }, "2", -1)),
                              _createElementVNode("div", _hoisted_33, [
                                _cache[55] || (_cache[55] = _createElementVNode("span", { class: "step-title" }, "열린 창 주소창에 경로 붙여넣기", -1)),
                                _cache[56] || (_cache[56] = _createElementVNode("span", { class: "step-desc" }, "경로를 복사한 뒤 창 위쪽 주소창에 붙여넣고 Enter", -1)),
                                _createElementVNode("div", _hoisted_34, [
                                  _cache[54] || (_cache[54] = _createElementVNode("code", null, "%USERPROFILE%\\AppData\\LocalLow\\NPKI", -1)),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "copy-path-btn",
                                    onClick: copyNpkiPath
                                  }, [
                                    _createVNode(_component_v_icon, { size: "14" }, {
                                      default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                                        _createTextVNode("mdi-content-copy", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ])
                            ]),
                            _cache[59] || (_cache[59] = _createElementVNode("div", { class: "guide-step" }, [
                              _createElementVNode("div", { class: "step-number" }, "3"),
                              _createElementVNode("div", { class: "step-content" }, [
                                _createElementVNode("span", { class: "step-title" }, "내 인증서 폴더까지 이동"),
                                _createElementVNode("span", { class: "step-desc" }, [
                                  _createTextVNode(" 인증기관 폴더(예: yessign, SignKorea) → "),
                                  _createElementVNode("b", null, "USER"),
                                  _createTextVNode(" → 본인 인증서 폴더(cn=… 형태)를 선택하고 「폴더 선택」 확인 ")
                                ]),
                                _createElementVNode("span", { class: "step-desc step-desc--tip" }, " 인증서가 여러 개면 USER를 통째로 고르지 말고, 사용할 인증서 폴더 하나만 선택하세요. ")
                              ])
                            ], -1)),
                            _cache[60] || (_cache[60] = _createElementVNode("div", { class: "guide-step" }, [
                              _createElementVNode("div", { class: "step-number" }, "4"),
                              _createElementVNode("div", { class: "step-content" }, [
                                _createElementVNode("span", { class: "step-title" }, "자동 인식 확인"),
                                _createElementVNode("span", { class: "step-desc" }, [
                                  _createElementVNode("span", { class: "file-badge cert" }, "signCert.der"),
                                  _createTextVNode(" / "),
                                  _createElementVNode("span", { class: "file-badge key" }, "signPri.key"),
                                  _createTextVNode(" 가 자동으로 채워집니다. 그 다음 비밀번호만 입력하면 됩니다. ")
                                ]),
                                _createElementVNode("span", { class: "step-desc step-desc--tip" }, " USB·다른 PC에 복사해 둔 인증서도 같은 방법으로 폴더만 선택하면 됩니다. ")
                              ])
                            ], -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_v_icon, {
                            size: "16",
                            color: "primary"
                          }, {
                            default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                              _createTextVNode("mdi-account-key", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[62] || (_cache[62] = _createElementVNode("span", null, [
                            _createTextVNode(" 희망이음은 "),
                            _createElementVNode("b", null, "개인(personal) 공동인증서"),
                            _createTextVNode("가 필요합니다. 롱텀케어에 등록한 "),
                            _createElementVNode("b", null, "법인 인증서와 다릅니다"),
                            _createTextVNode(" — 희망이음용 개인 인증서를 별도로 등록해주세요. ")
                          ], -1))
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_v_icon, {
                            size: "14",
                            color: "info"
                          }, {
                            default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                              _createTextVNode("mdi-login", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[64] || (_cache[64] = _createElementVNode("span", null, [
                            _createTextVNode(" 희망이음(ssis.go.kr) 로그인 "),
                            _createElementVNode("b", null, "아이디·비밀번호"),
                            _createTextVNode("도 함께 입력해야 마감요청 자동 업로드 등 자동화 기능이 동작합니다. ")
                          ], -1))
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _cache[78] || (_cache[78] = _createElementVNode("label", null, [
                            _createTextVNode("인증서 파일 "),
                            _createElementVNode("span", { class: "required" }, "*")
                          ], -1)),
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "cert-folder-pick-btn",
                              onClick: triggerFolderInput
                            }, [
                              _createVNode(_component_v_icon, {
                                size: "18",
                                class: "mr-1"
                              }, {
                                default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                                  _createTextVNode("mdi-folder-open", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[66] || (_cache[66] = _createTextVNode(" 인증서 폴더 선택 ", -1))
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "cert-files-pick-btn",
                              onClick: triggerFileInput
                            }, [
                              _createVNode(_component_v_icon, {
                                size: "16",
                                class: "mr-1"
                              }, {
                                default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                                  _createTextVNode("mdi-file-multiple-outline", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[68] || (_cache[68] = _createTextVNode(" 파일 2개 직접 선택 ", -1))
                            ])
                          ]),
                          _createElementVNode("input", {
                            type: "file",
                            ref_key: "folderInputRef",
                            ref: folderInputRef,
                            style: {"display":"none"},
                            onChange: onFolderChange
                          }, null, 544),
                          _createElementVNode("div", {
                            class: _normalizeClass(["file-drop-zone", { 'drag-over': isDragOver.value, 'has-files': signCertFile.value && signPriFile.value }]),
                            onDragover: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (isDragOver.value = true), ["prevent"])),
                            onDragleave: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (isDragOver.value = false), ["prevent"])),
                            onDrop: _withModifiers(onDrop, ["prevent"])
                          }, [
                            _createElementVNode("input", {
                              type: "file",
                              ref_key: "fileInputRef",
                              ref: fileInputRef,
                              accept: ".der,.key",
                              multiple: "",
                              onChange: onFilesChange,
                              style: {"display":"none"}
                            }, null, 544),
                            (!signCertFile.value && !signPriFile.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  _createVNode(_component_v_icon, {
                                    size: "32",
                                    color: isDragOver.value ? 'primary' : 'grey-lighten-1'
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(isDragOver.value ? 'mdi-file-download' : 'mdi-folder-upload-outline'), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["color"]),
                                  _cache[69] || (_cache[69] = _createElementVNode("span", { class: "drop-text" }, "위 버튼으로 폴더를 선택하거나, 파일을 여기에 드래그하세요", -1)),
                                  _cache[70] || (_cache[70] = _createElementVNode("span", { class: "drop-hint" }, "권장: 인증서 폴더 통째 선택 → der/key 자동 인식", -1))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["file-item", { 'has-file': signCertFile.value }])
                                  }, [
                                    (signCertFile.value)
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          size: "16",
                                          color: "success"
                                        }, {
                                          default: _withCtx(() => [...(_cache[71] || (_cache[71] = [
                                            _createTextVNode("mdi-check-circle", -1)
                                          ]))]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 1,
                                          size: "16",
                                          color: "grey-lighten-1"
                                        }, {
                                          default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
                                            _createTextVNode("mdi-close-circle", -1)
                                          ]))]),
                                          _: 1
                                        })),
                                    _cache[73] || (_cache[73] = _createElementVNode("span", { class: "file-badge cert" }, "signCert.der", -1)),
                                    _createElementVNode("span", _hoisted_41, _toDisplayString(signCertFile.value ? signCertFile.value.name : '선택 안됨'), 1)
                                  ], 2),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["file-item", { 'has-file': signPriFile.value }])
                                  }, [
                                    (signPriFile.value)
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          size: "16",
                                          color: "success"
                                        }, {
                                          default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                                            _createTextVNode("mdi-check-circle", -1)
                                          ]))]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 1,
                                          size: "16",
                                          color: "grey-lighten-1"
                                        }, {
                                          default: _withCtx(() => [...(_cache[75] || (_cache[75] = [
                                            _createTextVNode("mdi-close-circle", -1)
                                          ]))]),
                                          _: 1
                                        })),
                                    _cache[76] || (_cache[76] = _createElementVNode("span", { class: "file-badge key" }, "signPri.key", -1)),
                                    _createElementVNode("span", _hoisted_42, _toDisplayString(signPriFile.value ? signPriFile.value.name : '선택 안됨'), 1)
                                  ], 2),
                                  (pickedFolderHint.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_43, "폴더: " + _toDisplayString(pickedFolderHint.value), 1))
                                    : _createCommentVNode("", true),
                                  _cache[77] || (_cache[77] = _createElementVNode("span", { class: "change-hint" }, "위에서 다시 선택하면 변경됩니다", -1))
                                ]))
                          ], 34)
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _cache[81] || (_cache[81] = _createElementVNode("label", null, [
                            _createTextVNode("인증서 비밀번호 "),
                            _createElementVNode("span", { class: "required" }, "*")
                          ], -1)),
                          _createElementVNode("div", _hoisted_45, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((certPassword).value = $event)),
                              type: showCertPw.value ? 'text' : 'password',
                              class: "native-input full-width",
                              placeholder: "인증서 비밀번호"
                            }, null, 8, _hoisted_46), [
                              [_vModelDynamic, certPassword.value]
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "toggle-password-btn",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (showCertPw.value = !showCertPw.value))
                            }, [
                              _createVNode(_component_v_icon, { size: "18" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(showCertPw.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _createVNode(_component_v_icon, {
                              size: "12",
                              color: "warning",
                              class: "mr-1"
                            }, {
                              default: _withCtx(() => [...(_cache[79] || (_cache[79] = [
                                _createTextVNode("mdi-alert", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[80] || (_cache[80] = _createTextVNode(" 등록 시 비밀번호가 이 인증서와 일치하는지 자동으로 확인됩니다. ", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _cache[82] || (_cache[82] = _createElementVNode("label", null, [
                            _createTextVNode("희망이음 아이디 "),
                            _createElementVNode("span", { class: "required" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((hopeId).value = $event)),
                            type: "text",
                            class: "native-input full-width",
                            placeholder: "희망이음 로그인 아이디",
                            name: "hope_ssis_login_id",
                            autocomplete: "off",
                            autocapitalize: "off",
                            spellcheck: "false"
                          }, null, 512), [
                            [_vModelText, hopeId.value]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _cache[83] || (_cache[83] = _createElementVNode("label", null, [
                            _createTextVNode("희망이음 비밀번호 "),
                            _createElementVNode("span", { class: "required" }, "*")
                          ], -1)),
                          _createElementVNode("div", _hoisted_50, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((hopePw).value = $event)),
                              type: showHopePw.value ? 'text' : 'password',
                              class: "native-input full-width",
                              placeholder: "희망이음 로그인 비밀번호",
                              name: "hope_ssis_login_pw",
                              autocomplete: "new-password"
                            }, null, 8, _hoisted_51), [
                              [_vModelDynamic, hopePw.value]
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "toggle-password-btn",
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (showHopePw.value = !showHopePw.value))
                            }, [
                              _createVNode(_component_v_icon, { size: "18" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(showHopePw.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createVNode(_component_v_icon, {
                            size: "14",
                            color: "warning"
                          }, {
                            default: _withCtx(() => [...(_cache[84] || (_cache[84] = [
                              _createTextVNode("mdi-shield-lock", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[85] || (_cache[85] = _createElementVNode("span", null, "인증서·아이디·비밀번호는 모두 AES-256으로 암호화되어 저장됩니다.", -1))
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
          ]),
          _createElementVNode("div", _hoisted_53, [
            (certInfo.value && editMode.value === 'full')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "delete-btn",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (showDeleteDialog.value = true)),
                  disabled: saving.value
                }, [
                  _createVNode(_component_v_icon, {
                    size: "14",
                    class: "mr-1"
                  }, {
                    default: _withCtx(() => [...(_cache[86] || (_cache[86] = [
                      _createTextVNode("mdi-delete", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[87] || (_cache[87] = _createTextVNode(" 삭제 ", -1))
                ], 8, _hoisted_54))
              : _createCommentVNode("", true),
            _cache[91] || (_cache[91] = _createElementVNode("div", { class: "footer-spacer" }, null, -1)),
            _createElementVNode("button", {
              class: "cancel-btn",
              onClick: closeModal,
              disabled: saving.value
            }, "취소", 8, _hoisted_55),
            (certInfo.value && editMode.value === 'password')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "save-btn",
                  onClick: changePassword,
                  disabled: !newPassword.value.trim() || saving.value
                }, [
                  (saving.value)
                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                        key: 0,
                        indeterminate: "",
                        size: "14",
                        width: "2",
                        class: "mr-1"
                      }))
                    : (_openBlock(), _createBlock(_component_v_icon, {
                        key: 1,
                        size: "14",
                        class: "mr-1"
                      }, {
                        default: _withCtx(() => [...(_cache[88] || (_cache[88] = [
                          _createTextVNode("mdi-content-save", -1)
                        ]))]),
                        _: 1
                      })),
                  _createTextVNode(" " + _toDisplayString(saving.value ? '저장 중...' : '비밀번호 변경'), 1)
                ], 8, _hoisted_56))
              : (certInfo.value && editMode.value === 'credentials')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "save-btn",
                    onClick: changeCredentials,
                    disabled: !hopeId.value.trim() || !hopePw.value.trim() || saving.value
                  }, [
                    (saving.value)
                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                          key: 0,
                          indeterminate: "",
                          size: "14",
                          width: "2",
                          class: "mr-1"
                        }))
                      : (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          size: "14",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[89] || (_cache[89] = [
                            _createTextVNode("mdi-content-save", -1)
                          ]))]),
                          _: 1
                        })),
                    _createTextVNode(" " + _toDisplayString(saving.value ? '저장 중...' : '아이디/비번 변경'), 1)
                  ], 8, _hoisted_57))
                : (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    class: "save-btn",
                    onClick: upload,
                    disabled: !canUpload.value || saving.value
                  }, [
                    (saving.value)
                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                          key: 0,
                          indeterminate: "",
                          size: "14",
                          width: "2",
                          class: "mr-1"
                        }))
                      : (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          size: "14",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[90] || (_cache[90] = [
                            _createTextVNode("mdi-upload", -1)
                          ]))]),
                          _: 1
                        })),
                    _createTextVNode(" " + _toDisplayString(saving.value ? '업로드 중...' : (certInfo.value ? '인증서 변경' : '등록')), 1)
                  ], 8, _hoisted_58))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showDeleteDialog.value,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((showDeleteDialog).value = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("button", {
            type: "button",
            class: "dialog-x-close",
            "aria-label": "닫기",
            disabled: saving.value,
            onClick: _cache[19] || (_cache[19] = ($event: any) => (showDeleteDialog.value = false))
          }, [
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[92] || (_cache[92] = [
                _createTextVNode("mdi-close", -1)
              ]))]),
              _: 1
            })
          ], 8, _hoisted_60),
          _createElementVNode("div", _hoisted_61, [
            _createVNode(_component_v_icon, {
              size: "48",
              color: "error"
            }, {
              default: _withCtx(() => [...(_cache[93] || (_cache[93] = [
                _createTextVNode("mdi-alert-circle", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[95] || (_cache[95] = _createElementVNode("h3", null, "희망이음 인증서 삭제", -1)),
          _cache[96] || (_cache[96] = _createElementVNode("p", null, [
            _createTextVNode("등록된 희망이음 공동인증서를 삭제하시겠습니까?"),
            _createElementVNode("br"),
            _createTextVNode("삭제 후에는 복구할 수 없습니다.")
          ], -1)),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("button", {
              class: "cancel-btn",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (showDeleteDialog.value = false))
            }, "취소"),
            _createElementVNode("button", {
              class: "delete-btn",
              onClick: deleteCert,
              disabled: saving.value
            }, [
              (saving.value)
                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                    key: 0,
                    indeterminate: "",
                    size: "14",
                    width: "2",
                    class: "mr-1"
                  }))
                : _createCommentVNode("", true),
              _cache[94] || (_cache[94] = _createTextVNode(" 삭제 ", -1))
            ], 8, _hoisted_63)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: snackbar.value,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((snackbar).value = $event)),
      timeout: 2000,
      color: snackbarColor.value,
      location: "bottom"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackbarText.value), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color"])
  ]))
}
}

})